import { render, staticRenderFns } from "./attention.vue?vue&type=template&id=05bce22e&scoped=true"
import script from "./attention.vue?vue&type=script&lang=js"
export * from "./attention.vue?vue&type=script&lang=js"
import style0 from "./attention.vue?vue&type=style&index=0&id=05bce22e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05bce22e",
  null
  
)

export default component.exports